import {MarkerFeature} from "./MarkerFeature";
import {LineStringFeature} from "./LineStringFeature";

export interface Route {
  id: string;
  name: string;
  markers: MarkerFeature[];
  lineStrings: LineStringFeature[];
  created_at: Date;
  updated_at: Date;
  route_style?: 'route' | 'alt' | 'spur' | 'transport';
  undoMarkers: MarkerFeature[][];
  redoMarkers: MarkerFeature[][];
  undoLineStrings: LineStringFeature[][];
  redoLineStrings: LineStringFeature[][];
  plannedTrailId?: number;
  isReference?: boolean;
  referencedHikes?: Array<{ id: string; name: string; slug: string }>;
  position: number;
  day?: number;
}

export class RouteFactory {
  static createNew(name: string = 'New route', position: number = 0, day?: number): Route {
    const now = new Date();
    return {
      id: `route_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      name,
      markers: [],
      lineStrings: [],
      created_at: now,
      updated_at: now,
      route_style: 'route', // Default to 'route'
      undoMarkers: [],
      redoMarkers: [],
      undoLineStrings: [],
      redoLineStrings: [],
      position,
      day
    };
  }

  static fromLegacyData(
    markers: MarkerFeature[],
    lineStrings: LineStringFeature[],
    name: string = 'Route 1',
    position: number = 0,
    options?: {
      plannedTrailId?: string;
      referencedHikes?: Array<{ id: string; name: string; slug: string }>;
      day?: number;
      route_style?: 'route' | 'alt' | 'spur' | 'transport';
    }
  ): Route {
    const now = new Date();
    const route: Route = {
      id: `route_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      name,
      markers: [...markers],
      lineStrings: [...lineStrings],
      created_at: now,
      updated_at: now,
      route_style: options?.route_style ?? 'route', // Use provided route_style or default to 'route'
      undoMarkers: [],
      redoMarkers: [],
      undoLineStrings: [],
      redoLineStrings: [],
      position,
      day: options?.day ?? 1
    };

    // Add reference fields if this is a reference
    if (options?.plannedTrailId) {
      route.plannedTrailId = Number(options.plannedTrailId);
      route.isReference = true;
      route.referencedHikes = options.referencedHikes || [];
    }

    return route;
  }
}